import { render, staticRenderFns } from "./ShortATC.vue?vue&type=template&id=2abac118&scoped=true&"
import script from "./ShortATC.vue?vue&type=script&lang=js&"
export * from "./ShortATC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abac118",
  null
  
)

export default component.exports